import Modal from "react-bootstrap/Modal";
import { UserCertCreation } from "../components/UserCertCreation";

const UserCertificationCreateUpdateModal = ({
  visible,
  close,
  user,
  cert,
  updateCert,
}) => {
  return (
    <Modal
      show={visible}
      onHide={close}
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title
          id="contained-modal-title-vcenter"
          className={"text-capitalize"}
        >
          User Certification{" "}
          {cert !== null && cert !== undefined ? "Edit" : "Create"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserCertCreation
          cert={cert}
          defaultUser={user}
          onComplete={(c) => {
            if (updateCert !== null && updateCert !== undefined) updateCert(c);
            close();
          }}
          close={close}
          type={cert !== null && cert !== undefined ? "edit" : "create"}
        />
      </Modal.Body>
    </Modal>
  );
};

export default UserCertificationCreateUpdateModal;
